module.exports = __webpack_public_path__ + "img/7@2x-en.4f2bdd28.png";